import { motion } from 'motion/react';

import CheckIcon from '@common/assets/icons/check.svg?react';

import styles from './Steps.module.scss';

export interface StepsProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  testId: string;
  steps: number;
  currentStep: number;
  onStepClick?: (step: number) => void;
}

export const Steps = ({
  testId,
  steps,
  currentStep,
  onStepClick,
  ...props
}: StepsProps) => {
  const progressBar = ((currentStep - 1) / (steps - 1)) * 100;

  return (
    <div
      {...props}
      className={styles.steps}
      data-test-id={`${testId}-container`}
    >
      <div className={styles.bgLine} />

      <motion.div
        className={styles.progressLine}
        data-test-id={`${testId}-progress-line`}
        animate={{ width: `${progressBar}%` }}
        transition={{ duration: 0.3 }}
      />

      <div className={styles.dots}>
        {Array(steps)
          .fill(0)
          .map((_, index) => {
            let status: 'active' | 'completed' | 'default' = 'default';

            if (currentStep === index + 1) {
              status = 'active';
            } else if (currentStep > index + 1) {
              status = 'completed';
            }

            return (
              <div
                key={index}
                className={styles.dot}
                data-status={status}
                data-test-id={`${testId}-dot-${index + 1}`}
                onClick={onStepClick ? () => onStepClick(index + 1) : undefined}
              >
                {index + 1 < currentStep ? <CheckIcon /> : index + 1}
              </div>
            );
          })}
      </div>
    </div>
  );
};
